export const ACCOUNTS = {
  RENT_ACCOUNT: {
    NAME: 'rentAccount',
    PATH_URL: 'Aditivo_Emprestimo_Acoes.pdf'
  },
  MARGIN_ACCOUNT: {
    NAME: 'marginAccount',
    PATH_URL: 'Aditivo_Conta_Margem.pdf'
  }
}
export const VALIDATION = {
  REQUIRED: 'Campo obrigatório',
  CNPJ_VALIDATE: 'Informe um CNPJ válido'
}


export const TAGS = {
  ORIGIN: {
    MORE: 'Mais'
  },
  LOAD_SETTINGS: 'acompanhar_entrarmais',
  SETTINGS: {
    LEARN_TO_INVEST: 'aprender_mais_entraraprenderainvestir',
    SEE_STATEMENTS: 'acompanhar_verextrato',
    CLICK_WHERE_TO_INVEST: 'aprender_clicarbannerondeinvestir'
  },
  WITHDRAWAL: {
    SHOW_SUCCESS: 'retirar_sucesso_exibirsucesso'
  },
  INCOME_REPORT: {
    REQUEST_REPORT: 'acompanhar_solicitar_informerendimentos'
  },
  HELP: {
    GET_HELP: 'acessar_area_ajuda',
    FAQ: 'ajuda_acessar_perguntas_frequentes',
    CHAT: 'ajuda_acessar_chat',
    EMAIL: 'ajuda_enviar_uma_mensagem',
    SUNSHINE_CHAT: 'ajuda_acessar_chat_sunshine',
    CLASSIC_CHAT_SUCCESS: 'ajuda_acessar_chat_classico_sucesso',
    CLASSIC_CHAT_ERROR: 'ajuda_acessar_chat_classico_erro'
  },
  CUSTODY_TRANSFER: {
    HOME: {
      LOAD: 'transferenciacustodia_home_entrar',
      VIDEO: 'transferenciacustodia_home_cliquevideo',
      IN: 'transferenciacustodia_home_portabilidadeentrada',
      OUT: 'transferenciacustodia_home_portabilidadesaida',
      FOLLOW_REQUEST: 'transferenciacustodia_home_acompanharpedido'
    },
    IN: {
      LOAD: 'transferenciacustodia_portabilidadeentrada_instrucoesestaticas_entrar'
    },
    OUT: {
      LINK_1: 'transferenciacustodia_acompanharpedido_downloadstvmfundos',
      LINK_2: 'transferenciacustodia_acompanharpedido_downloadstvmtodosprodutos',
      CONFIRMATION: {
        DONE: 'transferenciacustodia_portabilidadesaida_extratocustodia_concluir',
        BACK: 'transferenciacustodia_portabilidadesaida_extratocustodia_voltar',
        SUBMIT: 'transferenciacustodia_portabilidadesaida_autenticacao_continuar',
        CANCEL: 'transferenciacustodia_portabilidadesaida_extratocustodia_cancelar'
      },
      RESULT: {
        CANCELLED: 'transferenciacustodia_portabilidadesaida_pedidocancelado_entrar',
        BUTTON: 'transferenciacustodia_portabilidadesaida_sucesso_acompanharpedido',
        SUCCESS: 'transferenciacustodia_portabilidadesaida_sucesso_transferenciarealizada'
      }
    },
    MODAL: {
      OK: 'transferenciacustodia_portabilidadesaida_modalinformacoes_ok',
      RELATED_PERSON: 'transferenciacustodia_portabilidadesaida_modalpossuivinculo_fechar',
      CANCEL: 'transferenciacustodia_portabilidadesaida_cancelarpedido_escolher',
      TRACK_REQUEST: 'transferenciacustodia_home_acompanharpedido',
      CLOSE: 'transferenciacustodia_acompanharpedido_fechar',
      FOLLOW_REQUEST: {
        CLOSE: 'transferenciacustodia_acompanharpedido_fechar'
      }
    }
  },
  EARNINGS: {
    BDRS: 'acompanhar_verproventos_distribuidos_bdrs',
    STOCKS: 'acompanhar_verproventos_distribuidos_acoes',
    FIIS: 'acompanhar_verproventos_distribuidos_fiis',
    FILTER_MONTHLY: 'acompanhar_verproventos_grafico_mes',
    FILTER_YEARLY: 'acompanhar_verproventos_grafico_ano',
    GRAPHIC_CLICK: 'acompanhar_verproventos_grafico_clique',
    FILTER_FIIS: 'acompanhar_verproventos_grafico_fiis',
    FILTER_STOCKS: 'acompanhar_verproventos_grafico_acoes',
    FILTER_BDRS: 'acompanhar_verproventos_grafico_bdrs',
    FILTER_ALL: 'acompanhar_verproventos_grafico_carteira',
    MENU_EARNINGS: 'acompanhar_entrarmais_verproventos'
  }
}

export const CONFIG_GREG_ALERT = {
  LOCAL_STORAGE: 'pendency_alert_timer',
  INTERVAL: 1000 * 60 * 5,
  CLEAN_ALERT_DATA: {
    type: '',
    title: '',
    text: '',
    button: {
      hasButton: false
    }
  }
}

export const PENDENCY_TYPES = {
  CLARIFICATIONS: 'Clarifications',
  INFORMATIONS: 'Informations',
  REGISTER: 'Register',
  SFP: 'Sfp',
  SUITABILITY: 'Suitability',
  TERM: 'Term',
  UPDATE_REGISTRY: 'UpdateRegistry',
  UPLOAD: 'Upload',
  JUDICIAL: 'Judicial',
  ANALYZE: 'Analyze',
  PENDING: 'Pending',
  DEFAULT: 'Default'
}
export const PENDENCY_ALERT = {
  [PENDENCY_TYPES.ANALYZE]: {
    type: 'info',
    title: 'Cadastro em análise!',
    text: `As informações do seu cadastro estão em análise e em até 3 dias
      úteis você receberá uma resposta. Fique de olho.`,
    button: {
      hasButton: false
    }
  },
  [PENDENCY_TYPES.UPDATE_REGISTRY]: {
    type: 'alert',
    title: 'Atualize seu cadastro!',
    text: 'Por conta dos orgãos regulatórios, precisamos manter seus dados sempre atualizados',
    button: {
      hasButton: true,
      text: 'Atualizar cadastro'
    }
  },
  [PENDENCY_TYPES.DEFAULT]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, faça os ajustes ;)',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.CLARIFICATIONS]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, faça os ajustes ;)',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.INFORMATIONS]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, faça os ajustes ;)',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.REGISTER]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para começar a investir, é necessário completar o cadastro. Vamos lá?',
    button: {
      hasButton: true,
      text: 'Completar cadastro'
    }
  },
  [PENDENCY_TYPES.SFP]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, faça os ajustes ;)',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.SUITABILITY]: {
    type: 'alert',
    title: 'Qual é seu perfil de investidor?',
    text: `Faça agora o teste e tenha acesso a investimentos adequados
      ao seu perfil!`,
    button: {
      hasButton: true,
      text: 'Fazer teste'
    }
  },
  [PENDENCY_TYPES.TERM]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, ajuste suas pendências',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.UPLOAD]: {
    type: 'alert',
    title: 'Você possui pendências!',
    text: 'Para ter a experiência completa, faça os ajustes ;)',
    button: {
      hasButton: true,
      text: 'Ajustar pendências'
    }
  },
  [PENDENCY_TYPES.JUDICIAL]: {
    type: 'alert',
    title: 'Conta bloqueada por ordem judicial!',
    text: `Para maiores informações entre em contato com a nossa
      central de atendimento pelo telefone 3841-4515`,
    button: {
      hasButton: false
    }
  }
}

export const NOTIFICATIONS_LIST = {
  NOTIFICATIONS: [
    { type: 1, description: 'Permitir receber push', send: false },
    { type: 2, description: 'Permitir receber e-mails', send: true },
    { type: 3, description: 'Permitir receber SMS', send: true }
  ]
}

export const CUSTODY_TRANSFER_STATUS = {
  1: 'OPENED',
  2: 'UNDER_ANALYSIS',
  3: 'DONE',
  4: 'PARTIALLY_COMPLETED',
  5: 'NOT_AUTHORIZED',
  6: 'CUSTOMER_PENDING',
  7: 'NEW_BROKER_PENDING'
}

export const CUSTODY_TRANSFER_STATUS_COLOR = {
  OPENED: {
    bgColor: '#D8D8D8',
    fontColor: '#322828'
  },
  UNDER_ANALYSIS: {
    bgColor: '#4C0677',
    fontColor: '#FFFFFF'
  },
  DONE: {
    bgColor: '#627900',
    fontColor: '#FFFFFF'
  },
  PARTIALLY_COMPLETED: {
    bgColor: '#627900',
    fontColor: '#FFFFFF'
  },
  NOT_AUTHORIZED: {
    bgColor: '#B00000',
    fontColor: '#FFFFFF'
  },
  CUSTOMER_PENDING: {
    bgColor: '#FFBB00',
    fontColor: '#322828'
  },
  NEW_BROKER_PENDING: {
    bgColor: '#FFBB00',
    fontColor: '#322828'
  }
}

export const CUSTODY_TRANSFER_EXPERIMENT = 'custody_transfer_come_cotas'

export default ACCOUNTS
